import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

export const authGuard = (): Observable<boolean> => {
  const oidc = inject(OidcSecurityService);

  return oidc.isAuthenticated$.pipe(
    map(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        oidc
          .checkAuth()
          .pipe(take(1))
          .subscribe(() => {
            oidc.authorize();
          });

        return false;
      }
      return true;
    })
  );
};
